import { isFullFormValid } from "../../util/Validators";
import { validateInput } from "./UserRegistrationValidationService";
import _ from "lodash";

export const userRegistrationFormValidationInitialState = {
    userNameError: false,
    passwordError: false,
    firstNameError: false,
    lastNameError: false,
    addressError: false,
    cityError: false,
    stateError: false,
    zipError: false,
    mobilePhoneNumberError: false,
    officePhoneNumberError: false,
    emailError: false,
    countryError: false,
    companyNameError: false,

    userNameErrMsg: "",
    passwordErrMsg: "",
    firstNameErrMsg: "",
    lastNameErrMsg: "",
    companyNameErrMsg: "",
    addressErrMsg: "",
    cityErrMsg: "",
    reactStateErrMsg: "",
    zipErrMsg: "",
    mobilePhoneNumberErrMsg: "",
    officePhoneNumberErrMsg: "",
    emailErrMsg: "",
    countryErrMsg: "",
    isFormValid: true
}


export const UserRegistrationFormValidationReducer = (reactState, action) => {
    if (!action.payload) {
        return reactState;
    }
    let isValid = false;
    switch (action.type) {
        case "VALIDATE_USERNAME":
            let { userName } = action.payload;
            let userNameValidationState = validateInput('userName', userName);
            isValid = !userNameValidationState.hasError;
            let userNameErrMsg = userNameValidationState.error;
            return {
                ...reactState,
                ...({ userNameError: !isValid, userNameErrMsg: userNameErrMsg, isFormValid: isFullFormValid(reactState, 'userNameError', !isValid) })
            };
        case "VALIDATE_PASSWORD":
            let { password } = action.payload;
            let passwordValidationState = validateInput('password', password);
            isValid = !passwordValidationState.hasError;
            let passwordErrMsg = passwordValidationState.error;
            return {
                ...reactState,
                ...({ passwordError: !isValid, passwordErrMsg: passwordErrMsg, isFormValid: isFullFormValid(reactState, 'passwordError', !isValid) })
            };
        case "VALIDATE_FIRSTNAME":
            let { firstName } = action.payload;
            let firstNameValidationState = validateInput('firstName', firstName);
            isValid = !firstNameValidationState.hasError;
            let firstNameErrMsg = firstNameValidationState.error;
            return {
                ...reactState,
                ...({ firstNameError: !isValid, firstNameErrMsg: firstNameErrMsg, isFormValid: isFullFormValid(reactState, 'firstNameError', !isValid) })
            };
        case "VALIDATE_LASTNAME":
            let { lastName } = action.payload;
            let lastNameValidationState = validateInput('lastName', lastName);
            isValid = !lastNameValidationState.hasError;
            let lastNameErrMsg = lastNameValidationState.error;
            return {
                ...reactState,
                ...({ lastNameError: !isValid, lastNameErrMsg: lastNameErrMsg, isFormValid: isFullFormValid(reactState, 'lastNameError', !isValid) })
            };
        case "VALIDATE_COMPANYNAME":
            let { companyName } = action.payload;
            let companyNameValidationState = validateInput('companyName', companyName);
            isValid = !companyNameValidationState.hasError;
            let companyNameErrMsg = companyNameValidationState.error;
            return {
                ...reactState,
                ...({ companyNameError: !isValid, companyNameErrMsg: companyNameErrMsg, isFormValid: isFullFormValid(reactState, 'companyNameError', !isValid) })
            };
        case "VALIDATE_ADDRESS":
            let { address } = action.payload;
            let addressValidationState = validateInput('address', address);
            isValid = !addressValidationState.hasError;
            let addressErrMsg = addressValidationState.error;
            return {
                ...reactState,
                ...({ addressError: !isValid, addressErrMsg: addressErrMsg, isFormValid: isFullFormValid(reactState, 'addressError', !isValid) })
            };
        case "VALIDATE_CITY":
            let { city } = action.payload;
            let cityValidationState = validateInput('city', city);
            isValid = !cityValidationState.hasError;
            let cityErrMsg = cityValidationState.error;
            return {
                ...reactState,
                ...({ cityError: !isValid, cityErrMsg: cityErrMsg, isFormValid: isFullFormValid(reactState, 'cityError', !isValid) })
            };
        case "VALIDATE_STATE":
            let { state } = action.payload;
            let stateValidationState = validateInput('state', state);
            isValid = !stateValidationState.hasError;
            let stateErrMsg = stateValidationState.error;
            return {
                ...reactState,
                ...({ stateError: !isValid, stateErrMsg: stateErrMsg, isFormValid: isFullFormValid(reactState, 'stateError', !isValid) })
            };
        case "VALIDATE_COUNTRY":
            let { country } = action.payload;
            let countryValidationState = validateInput('country', country);
            isValid = !countryValidationState.hasError;
            let countryErrMsg = countryValidationState.error;
            return {
                ...reactState,
                ...({ countryError: !isValid, countryErrMsg: countryErrMsg, isFormValid: isFullFormValid(reactState, 'countryError', !isValid) })
            };
        case "VALIDATE_ZIP":
            let { zip, formData } = action.payload;
            let zipValidationState = validateInput('zip', zip, formData);
            isValid = !zipValidationState.hasError;
            let zipErrMsg = zipValidationState.error;
            let newState = {
                ...reactState,
                ...({ zipError: !isValid, zipErrMsg: zipErrMsg, isFormValid: isFullFormValid(reactState, 'zipError', !isValid) })
            };
            return newState;
        case "VALIDATE_MOBILEPHONENUMBER":
            let { mobilePhoneNumber } = action.payload;
            let mobilePhoneNumberValidationState = validateInput('mobilePhoneNumber', mobilePhoneNumber);
            isValid = !mobilePhoneNumberValidationState.hasError;
            let mobilePhoneNumberErrMsg = mobilePhoneNumberValidationState.error;
            return {
                ...reactState,
                ...({ mobilePhoneNumberError: !isValid, mobilePhoneNumberErrMsg: mobilePhoneNumberErrMsg, isFormValid: isFullFormValid(reactState, 'mobilePhoneNumberError', !isValid) })
            };
        case "VALIDATE_OFFICEPHONENUMBER":
            let { officePhoneNumber } = action.payload;
            if (_.isEmpty(officePhoneNumber)) {
                return {
                    ...reactState
                };
            }
            let officePhoneNumberValidationState = validateInput('officePhoneNumber', officePhoneNumber);
            isValid = !officePhoneNumberValidationState.hasError;
            let officePhoneNumberErrMsg = officePhoneNumberValidationState.error;
            return {
                ...reactState,
                ...({ officePhoneNumberError: !isValid, officePhoneNumberErrMsg: officePhoneNumberErrMsg, isFormValid: isFullFormValid(reactState, 'officePhoneNumberError', !isValid) })
            };
        case "VALIDATE_EMAIL":
            let { email } = action.payload;
            let emailValidationState = validateInput('email', email);
            isValid = !emailValidationState.hasError;
            let emailErrMsg = emailValidationState.error;
            return {
                ...reactState,
                ...({ emailError: !isValid, emailErrMsg: emailErrMsg, isFormValid: isFullFormValid(reactState, 'emailError', !isValid) })
            };

        default:
            return reactState
    }
}



